import { createRequestTypes } from '../utils';

export const FETCH_RAWMATS_FOR_SUBSTANCE = createRequestTypes('substanceRawMat/FETCH_RAWMATS_FOR_SUBSTANCE');